import { render, staticRenderFns } from "./FormularioCapa.vue?vue&type=template&id=445940d3&"
import script from "./FormularioCapa.vue?vue&type=script&lang=js&"
export * from "./FormularioCapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports